import { Spinner } from 'baseui/spinner'
import getError from '@/containers/SubscriptionFormPage/getError'
import MeterCompleteInformation from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MeterCompleteInformation'
import useElectricityMeter from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/useElectricityMeter'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

const MeterInformation = ({ type, hidden = false }) => {
  const {
    t,
    oldOccupant,
    errors,
    contractType,
    isValidPdl,
    pdlEligibilityLoading,
    pdlEligibilityPending,
    pdlEligibilityData,
    lastName,
    proSocialReason,
    enedisAuth,
    consentDate,
    css,
  } = useElectricityMeter({ type })

  if (!enedisAuth || hidden) {
    return null
  }

  return (
    <>
      <SDNotification
        type={'script'}
        primaryText={
          t('subscriptionForm:pdl_module.enedis_authorization.authorized') +
          ' ' +
          new Date(consentDate).toLocaleString('fr-FR')
        }
      />
      <SDNotification
        type={'warning'}
        hidden={!pdlEligibilityPending}
        primaryText={t('subscriptionForm:pdl_module.enedis_authorization.pending')}
      />
      {pdlEligibilityLoading && (
        <>
          <div className={css({ alignItems: 'center', display: 'flex' })}>
            <Spinner size='2rem' />
            <p className={css({ marginLeft: '0.625rem' })}>
              {t('subscriptionForm:pdl_module.eligibility_loading_info')}
            </p>
          </div>
          <p className={css({ margin: '0.625rem 0 0 0.625rem', fontStyle: 'italic', fontSize: '0.75rem' })}>
            {t('subscriptionForm:pdl_module.enedis_authorization.warning_no_response')}
          </p>
        </>
      )}
      {((contractType !== 'pro' && !lastName) || (contractType === 'pro' && !proSocialReason)) && isValidPdl && (
        <SDNotification type={'warning'} primaryText={t('subscriptionForm:pdl_module.eligibility_fill_name_info')} />
      )}
      {getError('pdlRepository', errors) && (
        <SDNotification type={'warning'} primaryText={getError('pdlRepository', errors)} />
      )}
      <MeterCompleteInformation currentValue={pdlEligibilityData} oldOccupant={oldOccupant} type={type} />
    </>
  )
}

export default MeterInformation
